export const formatIntakeMessageReceivedAt = (receivedAt, formatter = null) => {
    if (typeof receivedAt !== 'string' || receivedAt.trim() === '') {
        return 'Unknown time';
    }

    const receivedDate = new Date(receivedAt);
    if (Number.isNaN(receivedDate.getTime())) {
        return 'Unknown time';
    }

    const localFormatter = formatter || new Intl.DateTimeFormat(undefined, {
        dateStyle: 'medium',
        timeStyle: 'short'
    });

    return localFormatter.format(receivedDate);
};
